import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Page, DealStatusSelect } from '../shared';

import ReactTooltip from 'react-tooltip';

import Insights from './insights';

import Select from 'react-select';

import{
  getIcon
} from '../../util/icons';

import {
  syncSalesforceData,
} from '../../actions/integrations/salesforce';

import {
  IntegrationSelector
} from '../../selectors';

import {
  focusAfterTimeout,
  formatThousands,
  getDealCompletion,
  getClassModifierForConfidence,
  getDealItemsAtRisk,
  dealValueInUSD,
  dealAmountAsString,
  dealLastProgressedBy,
} from '../../util';

import {
  fetchDealsForTeam
} from '../../actions/deals';

import {
  fetchUserDataForTeam
} from '../../actions';

import { Redirect, Link } from 'react-router-dom';

const ENTIRE_TEAM_OPTION = {
  value: false,
  userData: null,
  label: 'Entire Team',
}

const DEALS_PER_PAGE = 5;
const MAX_PAGES_SHOWN = 7;//MUST BE ODD!

class DealsPage extends Component {

  state = {
    pageMessage: null,
    redirectingToDeal: false,
    viewingTeam: null,
    viewingTeamMember: null,
    currentPage: 1,
    sortBy: 'confidence',
    isSearching: false,
    searchString: '',
    graphBy: 'value-confidence',
    viewingDealsWithStatus: 'open',
    userDataForTeam: null,
    refreshingIntegrationData: false,
  }

  viewAndFetchDealsForTeam(team){

    const userDataForTeam = { ...team.leaderData, ...team.memberData }

    this.setState({
      viewingTeamMember: team._id !== (this.state.viewingTeam || {})._id ? null : this.state.viewingTeamMember,
      viewingTeam: team,
      userDataForTeam,
    });

    //if no user data attached to team, fetch it now
    if(!userDataForTeam || _.size(userDataForTeam) === 0){
      fetchUserDataForTeam(team, userDataForTeam => {
        //console.log('userDataForTeam: ', userDataForTeam);
        this.setState({
          userDataForTeam: { ...userDataForTeam.leaderData, ...userDataForTeam.memberData}
        });

        this.props.fetchDealsForTeam({
          ...team,
          leaderData: userDataForTeam.leaderData,
          memberData: userDataForTeam.memberData,
        });
      });
    }
    else{
      this.props.fetchDealsForTeam({
        ...team,
        leaderData: userDataForTeam.leaderData,
        memberData: userDataForTeam.memberData,
      });
    }
  }

  componentWillMount(){

    const { defaultTeam, teams, loadingMyTeams } = this.props;

    //fetch deals if unloaded
    if(defaultTeam){
      this.viewAndFetchDealsForTeam(defaultTeam);
    }
    else if(!loadingMyTeams && teams && teams.length > 0){
      this.viewAndFetchDealsForTeam(teams[0]);
    }
  }

  reloadDeals(){
    const {
      viewingTeam,
      userDataForTeam
    } = this.state;

    this.props.fetchDealsForTeam({
      ...viewingTeam,
      leaderData: userDataForTeam.leaderData,
      memberData: userDataForTeam.memberData,
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot){
    const { viewingTeam } = this.state;
    const { defaultTeam, teams, loadingMyTeams } = this.props;

    if(!viewingTeam){
      if(defaultTeam){
        this.viewAndFetchDealsForTeam(defaultTeam);
      }
      else if(!loadingMyTeams && teams && teams.length > 0){
        this.viewAndFetchDealsForTeam(teams[0]);
      }
    }
  }

  refreshIntegrationData(){
    if(this.state.refreshingIntegrationData){ return; }

    this.setState({ refreshingIntegrationData: true });

    syncSalesforceData(() => {
      this.setState({ refreshingIntegrationData: false });
      this.reloadDeals();
    });
  }

  getTeamMemberById(memberId){
    const { viewingTeam, userDataForTeam } = this.state;

    if(!viewingTeam || !userDataForTeam){
      return {}
    }
    else{
      return _.find(userDataForTeam, { _id: memberId });
    }
  }

  renderDealDuration({status, createdOn, estimatedCloseDate}){
    const daysOpen = moment().diff(createdOn.toDate(), 'days');
    const closedIn = moment(estimatedCloseDate).diff(createdOn.toDate(), 'days');

    const durationText = status === 'open' ? `Open ${daysOpen} day${daysOpen > 1 || daysOpen === 0 ? 's' : ''}` : (status === 'won' ? `Closed in ${closedIn} day${closedIn > 1 || closedIn === 0 ? 's' : ''}` : false);

    if(status === 'open'){
      return (
        <span> &middot; {durationText}</span>
      )
    }
    else if(status === 'won'){
      return (
        <span> &middot; {durationText}</span>
      )
    }
    else{
      return null;
    }
  }

  renderDealSource(source){
    return (
      <div className="deal-source salesforce">{getIcon('salesforce')}</div>
    );
  }

  renderDeal(deal){

    const { sortBy } = this.state;

    const { _id, name, status, estimatedValue, estimatedCloseDate, completion, itemsAtRisk, userId, createdOn, source, sf } = deal;

    const { confidence } = completion;

    const dealConfidenceClassModifier = getClassModifierForConfidence(confidence);

    const dealSalesPerson = this.getTeamMemberById(userId);

    const dealLastProgressed = dealLastProgressedBy(deal);

    return(
      <Link key={_id} to={`/deal/${_id}`}>
        <li className="deal">
          {source && this.renderDealSource(source)}
          <div className="deal-name fs-block">{name}</div>
          {sortBy !== 'close' &&
            <React.Fragment>
              <div className="deal-primary-info fs-block">{dealAmountAsString(deal)}</div>
              <div className="deal-secondary-info fs-block">{moment(estimatedCloseDate).format('MM/DD/YY')} &middot; {(dealSalesPerson || {}).name}{this.renderDealDuration(deal)}</div>
            </React.Fragment>
          }
          {sortBy === 'close' &&
            <React.Fragment>
              <div className="deal-primary-info fs-block">{moment(estimatedCloseDate).format('MM/DD/YY')}</div>
              <div className="deal-secondary-info fs-block">{dealAmountAsString(deal)} &middot; {(dealSalesPerson || {}).name}{this.renderDealDuration(deal)}</div>
            </React.Fragment>
          }

          {itemsAtRisk && itemsAtRisk.length > 0 &&
            <React.Fragment>
              <div data-for={`deal-${_id}-items-at-risk-count-tooltip`} data-tip={`Deal has ${itemsAtRisk.length} item${itemsAtRisk.length !== 1 ? 's' : ''} at risk`} className="deal-at-risk">{getIcon('warning')}<div className="count">{itemsAtRisk.length}</div></div>
              <ReactTooltip id={`deal-${_id}-items-at-risk-count-tooltip`} effect="solid" place="top" />
            </React.Fragment>
          }
          <div className="deal-confidence">
            <div className={`dial confidence-${dealConfidenceClassModifier}`} style={{width: '60px', height: '60px'}}>
              <div className="dial__progress" data-percent={confidence}></div>
              <div className="dial__content" style={{lineHeight: '50px'}}>{confidence}</div>
              <div className="dial__denominator">/100</div>
            </div>
          </div>
        </li>
      </Link>
    );
  };

  dealsWithViewingStatus(){
    const { viewingDealsWithStatus } = this.state;
    const { deals } = this.props;

    return _.filter(deals || [], { status: viewingDealsWithStatus });
  }

  dealsForViewingTeamOrMember(){
    const { viewingTeam, viewingTeamMember, viewingDealsWithStatus } = this.state;
    const deals = this.dealsWithViewingStatus();

    const mappedDeals = _.map(deals, deal => {

      const itemsAtRisk = getDealItemsAtRisk(deal);

      return {
        ...deal,
        searchString: `${(deal.name || '').toLowerCase()} ${(deal.product || '').toLowerCase()}`,
        completion: getDealCompletion(deal),
        itemsAtRisk,
      }
    });

    if(viewingTeamMember && viewingTeamMember._id){
      return _.filter(mappedDeals, deal => {
        return deal.userId == viewingTeamMember._id;
      }) || [];
    }
    else{
      //viewing entire team, return all deals from props as these contain deals for entire team
      return mappedDeals || [];
    }
  }

  filteredAndSortedDeals(){
    const { sortBy, viewingTeamMember, searchString, viewingDealsWithStatus } = this.state;
    const deals = this.dealsForViewingTeamOrMember();

    if(!deals){
      return [];
    }

    let dealsMatchingSearch = deals;

    const lowerCaseSearchString = searchString.toLowerCase();

    if(searchString && searchString !== ''){
      dealsMatchingSearch = _.filter(deals, deal => {
        return deal.searchString.indexOf(lowerCaseSearchString) > -1;
      });
    }

    //add sort value to deals
    const mappedDeals = _.map(dealsMatchingSearch, deal => {

      const valueInUSD = dealValueInUSD(deal);

      const sortValue = (sortBy === 'confidence' ? (-1 * deal.completion.confidence) :
                        (sortBy === 'close' ? deal.estimatedCloseDate :
                        (sortBy === 'atrisk' ? (-1000000000 * deal.itemsAtRisk.length - valueInUSD) : (-1 * valueInUSD))));

      return {
        ...deal,
        sortValue,
      }
    });

    //automatically filter out non-active deals
    let filteredDeals = _.filter(mappedDeals, deal => {
      return deal.completion.active;
    });

    if(sortBy === 'atrisk'){
      filteredDeals = _.filter(filteredDeals, deal => {
        return deal.itemsAtRisk.length > 0
      });
    }

    const sortedAndFilteredDeals = _.sortBy(filteredDeals, 'sortValue');

    return sortedAndFilteredDeals;
  }

  getDealsPage(){
    const { currentPage } = this.state;
    const filteredAndSortedDeals = this.filteredAndSortedDeals();

    const totalPageCount = Math.ceil(filteredAndSortedDeals.length / DEALS_PER_PAGE);

    const startAt = (currentPage - 1) * DEALS_PER_PAGE;
    const endAt = (currentPage) * DEALS_PER_PAGE;

    const dealsOnCurrentPage = _.slice(filteredAndSortedDeals, startAt, endAt);

    const prevPageEnabled = currentPage > 1;
    const nextPageEnabled = currentPage < totalPageCount;

    let pages = Array.from(new Array(totalPageCount),(val,index)=>index + 1);

    let firstPageShowing = currentPage - 4 <= 1;
    let lastPageShowing = currentPage + 4 >= totalPageCount;

    //need to trim to fit
    if(pages.length > MAX_PAGES_SHOWN){

      const MAX_PAGES_ABOVE_OR_BELOW = (MAX_PAGES_SHOWN - 1) / 2;

      console.log('MAX_PAGES_ABOVE_OR_BELOW: ', MAX_PAGES_ABOVE_OR_BELOW);

      if(currentPage > (totalPageCount / 2)){
        //will start with taking higher pages (since we might run out of pages above current page)
        const pagesAboveCurrent = Math.min(totalPageCount - currentPage, MAX_PAGES_ABOVE_OR_BELOW);
        console.log('pagesAboveCurrent: ', pagesAboveCurrent);
        pages = _.slice(pages, currentPage - (MAX_PAGES_SHOWN - 1 - pagesAboveCurrent) - 1, currentPage + pagesAboveCurrent);
      }
      else{
        //reverse of above
        const pagesBelowCurrent = Math.min(currentPage - 1, MAX_PAGES_ABOVE_OR_BELOW);
        console.log('pagesBelowCurrent: ', pagesBelowCurrent);
        pages = _.slice(pages, currentPage - pagesBelowCurrent - 1, currentPage + (MAX_PAGES_SHOWN - 1 - pagesBelowCurrent));
      }
    }

    return {
      allDeals: filteredAndSortedDeals,
      currentPage,
      dealsOnCurrentPage,
      totalPageCount,
      prevPageEnabled,
      nextPageEnabled,
      pages,
    };
  }

  goToPage(page){
    this.setState({
      currentPage: page
    });
  }

  goToPrevPage(){
    this.setState({
      currentPage: this.state.currentPage - 1
    });
  }
  goToNextPage(){
    this.setState({
      currentPage: this.state.currentPage + 1
    });
  }

  updateSortBy(sortBy){
    this.setState({
      currentPage: 1,
      sortBy,
    });
  }

  startSearchingDeals(){
    this.setState({
      isSearching: true,
      searchString: ''
    },() => {
      focusAfterTimeout(this, 'dealSearchInput');
    });
  }

  handleDealSearchBlur(){
    if(this.state.searchString === ''){
      this.setState({
        isSearching: false
      });
    }
  }

  updateSearchString(searchString){
    this.setState({
      searchString,
      currentPage: 1,
    });
  }

  renderDealListSearch(){
    const { isSearching, searchString } = this.state;

    return(
      <div className="deal-search">
        {isSearching &&
          <input
            value={searchString}
            ref={input => { this.dealSearchInput = input; }}
            type="text"
            placeholder="Name or product"
            onChange={e => { this.updateSearchString(e.target.value); }}
            onBlur={this.handleDealSearchBlur.bind(this)}
          />
        }
        {!isSearching &&
          <div
            className="start-search"
            onClick={this.startSearchingDeals.bind(this)}
            >{getIcon('search')}<span>Search</span></div>
        }
      </div>
    );
  }

  renderDealsSort(){
    const { sortBy, viewingDealsWithStatus } = this.state;

    const viewingDealsWithOpenStatus = viewingDealsWithStatus === 'open';

    return (
      <ul className="section-toggles deals-sort-by">
        {viewingDealsWithOpenStatus &&
          <li onClick={() => { this.updateSortBy('confidence'); }} className={sortBy === 'confidence' ? 'active' : ''}>Deal Confidence</li>
        }
        <li onClick={() => { this.updateSortBy('close'); }} className={sortBy === 'close' ? 'active' : ''}>Close Date</li>
        <li onClick={() => { this.updateSortBy('value'); }} className={sortBy === 'value' ? 'active' : ''}>Deal Value</li>
        {viewingDealsWithOpenStatus &&
          <React.Fragment>
            <li className="divider">|</li>
            <li onClick={() => { this.updateSortBy('atrisk'); }} className={sortBy === 'atrisk' ? 'active' : ''}>At Risk</li>
          </React.Fragment>
        }
      </ul>
    )
  }

  renderDeals(){

    const {
      allDeals,
      dealsOnCurrentPage,
      currentPage,
      totalPageCount,
      prevPageEnabled,
      nextPageEnabled,
      pages
    } = this.getDealsPage();

    const { sortBy, viewingTeamMember, viewingTeam, searchString, viewingDealsWithStatus } = this.state;

    return(
      <div className="page-section fourty">
        {/*<h2>Open Deals{viewingTeamMember && ` for ${viewingTeamMember.name}`}</h2>*/}
        <h2>Deals</h2>
        {this.renderDealListSearch()}
        {this.renderDealsSort()}
        {allDeals.length === 0 &&
          <p>{viewingTeamMember ? viewingTeamMember.firstName : (viewingTeam || {}).name} has no {sortBy === 'atrisk' ? 'at risk' : viewingDealsWithStatus} {searchString !== '' ? `deals matching \"${searchString}\"` : `deals`}.</p>
        }
        <ul className="deals-list">
          {_.map(dealsOnCurrentPage, this.renderDeal.bind(this))}
        </ul>
        {totalPageCount > 1 &&
          <div className="deals-pagination">
            <ul className="pages">
              {_.map(pages, page => {
                return <li
                  key={page}
                  className={page === currentPage ? 'active' : ''}
                  onClick={() => { this.goToPage(page); } }
                  >{page}</li>
              })}
            </ul>
            <button
              className="prev-button button grey-outline button-tiny"
              disabled={!prevPageEnabled}
              onClick={this.goToPrevPage.bind(this)}
            >&lt;</button>
            <button
              className="next-button button grey-outline button-tiny"
              disabled={!nextPageEnabled}
              onClick={this.goToNextPage.bind(this)}
            >&gt;</button>
          </div>
        }
      </div>
    )
  }

  renderDealInsights(){

    const { graphBy, viewingTeamMember } = this.state;

    const deals = this.filteredAndSortedDeals();

    return (
      <div className="page-section insights-section sixty">
        {/*<h2>Deal Insights{viewingTeamMember && ` for ${viewingTeamMember.name}`}</h2>*/}
        <h2>Deal Insights</h2>
        <ul className="section-toggles deals-graph-by">
          <li onClick={() => { console.log('Not implemented yet.'); }} className={graphBy === 'value-confidence' ? 'active' : ''}>Value * Confidence</li>
        </ul>
        <Insights
          onDealClick={dealId => { this.setState({ redirectingToDeal: dealId }); }}
          deals={this.dealsForViewingTeamOrMember()} />
      </div>
    )
  }

  getTeamUsersOptions(){
    const { viewingTeam, userDataForTeam } = this.state;
    const currentUserId = this.props.user.uid;

    if(!viewingTeam || !userDataForTeam){
      return [];
    }

    const memberOptions = _.map(userDataForTeam, user => {
      const { _id, name } = user;

      return {
        value: _id,
        userData: user,
        label: currentUserId === _id ? 'Me' : name
      }
    });

    console.log('userDataForTeam: ', userDataForTeam);
    console.log('memberOptions: ', memberOptions);

    return [
      ENTIRE_TEAM_OPTION,
      ...memberOptions,
    ];
  }

  getTeamOptions(){
    const { myTeams, teams } = this.props;

    let teamOptions = [];
    let myTeamIds = [];

    _.each(myTeams || [], team => {
      teamOptions.push({
        value: team._id,
        label: team.name
      });
      myTeamIds.push(team._id);
    });

    _.each(teams || [], team => {
      //if we haven't already added this team...
      if(myTeamIds.indexOf(team._id) === -1){
        teamOptions.push({
          value: team._id,
          label: team.name
        });
      }
    });

    return teamOptions;
  }

  getViewingTeamSelectValue(){
    const { viewingTeam } = this.state;

    if(!viewingTeam){
      return null;
    }

    const matchingTeam = _.find(this.getTeamOptions(), team => {
      return team.value === viewingTeam._id;
    });

    return matchingTeam;
  }

  getViewingTeamUserSelectValue(){
    const { viewingTeamMember } = this.state;

    if(!viewingTeamMember){
      return ENTIRE_TEAM_OPTION;
    }

    const matchingTeamMember = _.find(this.getTeamUsersOptions(), member => {
      return member.value === viewingTeamMember._id;
    });

    return matchingTeamMember || ENTIRE_TEAM_OPTION;
  }

  viewTeam(teamId){
    const { myTeams, teams } = this.props;

    const matchingTeam = _.find(_.union(myTeams, teams), { _id: teamId });

    this.setState({
      currentPage: 1,
    });

    this.viewAndFetchDealsForTeam(matchingTeam);
  }

  viewTeamUser(teamMember){
    const { viewingTeam } = this.props;

    this.setState({
      viewingTeamMember: teamMember,
      currentPage: 1,
    });
  }

  updateViewingDealsStatus(viewingDealsWithStatus){

    if(viewingDealsWithStatus !== 'open'){
      this.updateSortBy('close');
    }
    else{
      this.updateSortBy('confidence');
    }

    this.setState({
      viewingDealsWithStatus
    });
  }

  renderViewingDealsWithStatusSelect(){
    return (
      <DealStatusSelect
        value={this.state.viewingDealsWithStatus}
        onUpdate={newStatus => { this.updateViewingDealsStatus(newStatus); }}
      />
    )
  }

  renderTeamUserSelect(){
    const teamUsersOptions = this.getTeamUsersOptions();

    if(!teamUsersOptions || teamUsersOptions.length === 0){
      return null;
    }

    const selectedOption = this.getViewingTeamUserSelectValue();

    return (
      <Select
        classNamePrefix={'react-select'}
        className={`react-select-container member-select ${!selectedOption.value && 'none-selected'}`}
        value={selectedOption}
        options={teamUsersOptions}
        onChange={(option) => { this.viewTeamUser(option.userData) }}
        isSearchable={false}
      />
    )
  }

  renderTeamSelect(){

    const teamOptions = this.getTeamOptions();

    if(!teamOptions || teamOptions.length === 0){
      return null;
    }

    return (
      <Select
        classNamePrefix={'react-select'}
        className='react-select-container team-select'
        value={this.getViewingTeamSelectValue()}
        options={teamOptions}
        onChange={(option) => { this.viewTeam(option.value) }}
        isSearchable={false}
      />
    );
  }

  renderDealsPageTitle(){

    const deals = this.props.deals || [];

    const { viewingDealsWithStatus, viewingTeam, viewingTeamMember } = this.state;

    const dealTotalToDisplay = _.reduce(deals, (memo, deal) => {

      const valueInUSD = dealValueInUSD(deal);

      if(viewingTeamMember){
        return memo + (deal.status === viewingDealsWithStatus && deal.userId === viewingTeamMember._id ? valueInUSD : 0);
      }
      else{
        return memo + (deal.status === viewingDealsWithStatus ? valueInUSD : 0);
      }
    }, 0);
''
    const dealTotalLabel = viewingDealsWithStatus === 'open' ? 'in pipeline' : (viewingDealsWithStatus === 'won' ? 'in won deals' : 'in lost deals');

    return(
      <div className="page-title">
        <h1>{(viewingTeamMember || viewingTeam || {}).name}{`'`}s {viewingDealsWithStatus.substring(0,1).toUpperCase() + viewingDealsWithStatus.substring(1)} Deals</h1>
        <h3 className="fs-block">${formatThousands(dealTotalToDisplay)} {dealTotalLabel}</h3>
      </div>
    )
  }

  // getDealsForCurrentView(){
  //   const deals = this.props.deals || [];
  //
  //   const { viewingDealsWithStatus, viewingTeam, viewingTeamMember } = this.state;
  //
  //   return _.filter(deals, deal => {
  //
  //   });
  // }

  renderSyncIntegrationButton(){
    if(!this.props.integration || this.props.integration !== 'salesforce'){
      return null;
    }

    const { refreshingIntegrationData } = this.state;

    return (
      <React.Fragment>
        <div data-for="refresh-integration-data-tooltip" data-tip="Reload deals" onClick={this.refreshIntegrationData.bind(this)} className={`action ${refreshingIntegrationData ? 'spinning disabled' : ''}`}>{getIcon(refreshingIntegrationData ? 'refresh' : 'sync')}</div>
          {!refreshingIntegrationData &&
            <ReactTooltip id="refresh-integration-data-tooltip" effect="solid" place="top"/>
          }
      </React.Fragment>
    )
  }

  render(){

    if(this.state.redirectingToDeal){
      const redirectToUrl = `/deal/${this.state.redirectingToDeal}`;
      return <Redirect to={redirectToUrl} />
    }

    const deals = this.props.deals || [];

    const { viewingTeam } = this.state;

    const loading = !this.props.user || this.props.loadingMyTeams || this.props.loadingDeals || !viewingTeam;

    return (
      <Page
        pageClass="deals"
        loading={loading}
        pageMessage={this.state.pageMessage}
        clearMessage={() => { this.setState({ pageMessage: null }) }}
        hideSidebar={true}
      >
        {this.renderDealsPageTitle()}
        <div className="page-actions">
          <div className="select-group">
            {this.renderSyncIntegrationButton()}
            {this.renderViewingDealsWithStatusSelect()}
            {this.renderTeamSelect()}
            {this.renderTeamUserSelect()}
          </div>
        </div>

        <div className="page-content">
          {this.renderDeals()}
          {this.renderDealInsights()}
        </div>
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    myTeams: state.myTeams.data,
    loadingMyTeams: state.myTeams.loading,
    loadingDeals: state.deals.loading,
    deals: state.deals.data,
    defaultTeam: state.myTeams.data && (state.myTeams.data[0] || false) || false,
    teams: state.teams.data,
    integration: IntegrationSelector(state),
  }
}

export default connect(mapStateToProps, { fetchDealsForTeam })(DealsPage);



// WEBPACK FOOTER //
// ./src/components/deals/index.js